import { schema } from "normalizr";
import { arrayOfAttachments } from "./schema.attachments";

const expense = new schema.Entity(`expenses`);
const arrayOfExpenses = [expense];

expense.define({
  attachments: arrayOfAttachments,
});

export { expense, arrayOfExpenses };
